// extracted by mini-css-extract-plugin
export default {"root":"B578P","custom-icon-button-size":"_1Zr1b","customIconButtonSize":"_1Zr1b"};